import { Card, CardBody, Col } from "reactstrap";
import { IconsWithPrefixAndPostfixTitle } from "../../../../../constants";
import CommonPrefixAndPostfix from "./common/CommonPrefixAndPostfix";
import { TouchSpinSubTitle } from "../../../../../data/formsAndTable/forms/FormWidgets";
import CommonCardHeader from "../../../../../coreComponents/CommonCardHeader";

const IconsWithPrefixAndPostfix = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={IconsWithPrefixAndPostfixTitle} span={TouchSpinSubTitle} />
        <CardBody className="common-flex pre-post-touchspin">
          <CommonPrefixAndPostfix preIcon />
          <CommonPrefixAndPostfix postIcon />
        </CardBody>
      </Card>
    </Col>
  );
};
export default IconsWithPrefixAndPostfix;
